/* eslint-disable max-len */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import ReactModal from 'react-modal';
import QRCode from 'qrcode.react';
import swal from '../../lib/swal';
import swal2 from '../../lib/swal2';
import {getShortShareUrl} from '../../lib/services/scratch-ser';
// import {
//     queryParams
// } from '../../lib/services/query-params';
import Button from '../button/button.jsx';
import CloseButton from './close-button.jsx';
import style from './second-step.css';
import '../../assets/font/iconfont';
import copyText from '../../utils/copy-text.js';

const shareURL = (cityCode, shareId, exerciseId, role, videoId) => {
    const info = localStorage.getItem('XIAOHOUCODE_USERINFO');
    let baseUrl = `${location.protocol}//${location.host}`;
    if (location.host === 'localhost' || location.host === '0.0.0.0') {
        baseUrl = 'https://test.xiaohoucode.com';
    }
    // if (process.env.NODE_ENV === 'production') {
    //     if (!location.host.match(/^www./)) {
    //         baseUrl = `${location.protocol}//www.${location.host}`;
    //     }
    // }
    if (location.host === 'xiaohoucode.com') {
        baseUrl = `${location.protocol}//www.${location.host}`;
    }
    // eslint-disable-next-line max-len
    let url = `${baseUrl}/scratch/v3/share/?cid=${cityCode}&id=${info ? JSON.parse(info).id : null}&card=${info ? JSON.parse(info).card : null}&role=${role}&shareId=${shareId}&videoId=${videoId}#${exerciseId}`;
    if (videoId) {
        url = `${baseUrl}/xiaohoucode-share?shareId=${videoId}`;
    }
    return url;
};

const handleShowTips = () => {
    swal.swal(`· 个人中心入口：在官网、编程课堂登录后，点击右上角头像找到【个人中心】，进入【我的项目视频】即可`, {
        button: false
    });
};

const handleCopy = url => {
    copyText(url, () => {
        swal2.toast('复制成功\n*请用手机打开此链接哦～');
    }, () => {
        swal2.toast('复制失败，请重试');
    });
};

class SecondStep extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'HandleGetShortShareUrl'
        ]);
        this.state = {
            shareUrl: ''
        };

    }

    componentWillMount () {
        const {shareUrl} = this.state;
        const {cityCode, shareId, reduxProjectId, role, videoId} = this.props;
        const tempUrl = shareURL(cityCode, shareId, reduxProjectId, role, videoId);
        this.HandleGetShortShareUrl(tempUrl);
    }

    HandleGetShortShareUrl (url) {
        const base64Url = window.btoa(url);
        getShortShareUrl({url: base64Url}).then(res => {
            const {status} = res;
            if (status === 200) {
                const {data: {data}} = res;
                this.setState({
                    shareUrl: data || url
                });
            }
        })
            .catch(() => {
                this.setState({
                    shareUrl: url
                });
            });
    }

    render () {
        const props = this.props;
        const {shareUrl} = this.state;
        return (
            <ReactModal
                className={style.content}
                // eslint-disable-next-line react/jsx-sort-props
                contentLabel="分享项目"
                isOpen
                // eslint-disable-next-line react/jsx-sort-props
                onRequestClose={props.onCloseModal}
                overlayClassName={style.overlay}
                shouldCloseOnOverlayClick={false}
            >
                <CloseButton onClick={props.onCloseModal} />
                <div
                    className={style.bodyWxTitle}
                >
                    {/* {'快把你的图形化编程项目分享给小伙伴吧！'} */}
                    {/* {props.videoId ? (<div>
                        <span>{'项目视频生成啦！已发送同步至个人中心以及小程序中'}</span>
                        <div
                            className={style.smallTips}
                            onClick={handleShowTips}
                        >
                            {'?'}
                        </div>
                    </div>) : '快把你的图形化编程项目分享给小伙伴吧！'} */}
                    {'上传成功'}
                </div>
                <div className={style.modalBody}>
                    <div className={style.bodyWork}>
                        <QRCode
                            className={style.thum}
                            size={128}
                            value={shareUrl}
                            // value={shareURL(props.cityCode, props.shareId, props.reduxProjectId, props.role, props.videoId)}
                        />
                        <div className={style.bodyWorkTip}>{'微信扫码后即可分享'}</div>
                        {/* <div
                            className={style.bodyWorkDesc}
                        >
                            {'所有作品均可在个人中心查看'}
                        </div> */}
                    </div>
                </div>
                <div className={style.bodyWxFooter}>
                    <div className={style.publishContainer}>
                        {/* { props.publishState === 'publishing' && <span>{'发布中...'}</span>}
                        { props.publishState === 'published' &&
                            <span>
                                <svg
                                    aria-hidden="true"
                                    className={style.iconfont}
                                >
                                    <use xlinkHref="#icon-true" />
                                </svg>
                                <span>{'发布成功！'}</span>
                            </span>
                        } */}
                        { props.publishState === 'error' &&
                            <span>
                                <svg
                                    aria-hidden="true"
                                    className={style.iconfont}
                                >
                                    <use xlinkHref="#icon-warning" />
                                </svg>
                                {/* <span className={classNames(style.iconfont, iconStyle.iconfont, style.iconWarning)}>{'&#xe633;'}</span> */}
                                <span>{'发布失败！'}</span>
                                <span
                                    className={style.publishRetry}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={props.onPublishCommunity}
                                >{'点此重试'}</span>
                            </span>
                        }
                    </div>
                </div>
                <div className={style.modalFooter}>
                    <Button
                        className={style.btn}
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={() => {
                            handleCopy(shareUrl);
                        }}
                    >
                        {'复制分享链接'}
                    </Button>
                </div>
            </ReactModal>
        );
    }
}

SecondStep.propTypes = {
    cityCode: PropTypes.string,
    onCloseModal: PropTypes.func,
    onPublishCommunity: PropTypes.func,
    publishState: PropTypes.string,
    reduxProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role: PropTypes.string,
    shareId: PropTypes.string,
    thumbnail: PropTypes.string,
    videoId: PropTypes.string
};

export default SecondStep;
